import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { logError } from '@/lib/logger';

import { DocumentImageSize } from '@/lib/types';
import { DocumentTypeCode } from '@/apiClient';
export interface useGetImageByEntityIdOptions {
  shouldFetch?: boolean;
}

export function getImageByEntityIdCacheKey(
  documentEntityId: string | undefined,
  documentTypeCode: DocumentTypeCode,
  documentImageSize: DocumentImageSize = DocumentImageSize.s,
) {
  return `/api/Document/GetImageByEntityId?documentEntityId=${documentEntityId}&documentTypeCode=${documentTypeCode}&size=${documentImageSize}`;
}

export function useGetImageByEntityId(
  documentEntityId: string | undefined,
  documentTypeCode: DocumentTypeCode,
  documentImageSize: DocumentImageSize = DocumentImageSize.s,
  options?: useGetImageByEntityIdOptions,
) {
  const mergedOptions: useGetImageByEntityIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { documentApi } = usePrivate();

  const results = useSWR(
    documentApi && documentEntityId && mergedOptions.shouldFetch
      ? getImageByEntityIdCacheKey(
          documentEntityId,
          documentTypeCode,
          documentImageSize,
        )
      : null,
    () =>
      documentApi?.apiDocumentGetImageByEntityIdGet(
        documentEntityId,
        documentTypeCode,
        documentImageSize,
        {
          responseType: 'blob',
        },
      ),
    {
      onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
        if (retryCount > 1) {
          logError('[BREEDLOGIC] <DocumentImage>', error);
          return;
        }

        setTimeout(() => revalidate({ retryCount }), 1000);
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !documentApi;

  return { ...results, isLoadingOrValidating };
}
